import React, { useEffect, useRef, useState } from 'react';
import { usePrefersReducedMotion } from '@hooks';
import { ContactModal } from '@components';

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }
    // scroll reveal disabled intentionally
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section
        id="contact"
        ref={revealContainer}
        className="mb-[100px] max-[768px]:mb-[50px]">

        <h2 className="numbered-heading">What&apos;s Next?</h2>

        <div className="max-w-[600px] mx-auto text-center">
          <h2
            className="title"
            style={{ fontSize: 'clamp(40px, 5vw, 60px)' }}>
            Get In Touch
          </h2>

          <p>
            Although I&apos;m always excited to connect with fellow developers, researchers, and tech
            enthusiasts. Whether you want to discuss AI/ML projects, collaborate on innovative
            solutions, or just want to say hi, I&apos;ll try my best to get back to you!
          </p>

          {/* email-link class = bigButton styles (global.css) */}
          <button className="email-link mt-[50px]" onClick={() => setIsModalOpen(true)} type="button">
            Say Hello
          </button>
        </div>
      </section>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Contact;
